import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";
import { InboxFilterOptions } from "../components/thread-list-panel/InboxFilters";

export interface InboxQueryParams extends Omit<InboxFilterOptions, "dateRange"> {
  search?: string;
  dateRange?: {
    from?: string;
    to?: string;
  };
}

const VALID_INBOX_QUERY_PARAM_KEYS = [
  "search",
  "readStatus",
  "inboxStatus",
  "assignees",
  "tags",
  "patients",
  "channels",
  "dateRange.from",
  "dateRange.to",
  "scheduled",
] as const satisfies ExtractKeysWithDotNotation<InboxQueryParams>[];

const INBOX_ARRAY_KEYS = [
  "assignees", // Note: This appears to be a typo in the original code ("assigness" instead of "assignees")
  "tags",
  "patients",
  "channels",
  "inboxStatus",
] as const satisfies ExtractKeysWithDotNotation<InboxQueryParams>[];

export const useInboxSearchParams = () => {
  return useTypedSearchParams<InboxQueryParams>(VALID_INBOX_QUERY_PARAM_KEYS, INBOX_ARRAY_KEYS);
};
